import { useGet } from '../../HttpClient';
import { TenantHierarchy } from '@app/models';
import { tenantHierarchyBaseUrl } from '../BaseUrls';

const pillarCode = "tms";
 
export const useRawGetOrganisationHierarchy = () => {
  const get = useGet(true, pillarCode);
  return async () => await get<TenantHierarchy>(`${tenantHierarchyBaseUrl}/organisation-hierarchy`);
};